<form [formGroup]="registerForm">
  <div class="mb10">
    <rx-input
      formControlName="oldPassword"
      placeholder="Current Password"
      [keepPlaceholder]="true"
      type="password"
    ></rx-input>
  </div>

  <div class="mb10">
    <rx-input
      formControlName="newPassword"
      placeholder="New Password"
      rxFormControlError
      [keepPlaceholder]="true"
      [customErrors]="mustNotMatchError"
      type="password"
    ></rx-input>
  </div>

  <div class="mb10">
    <rx-input
      formControlName="confirmPassword"
      placeholder="Confirm Password"
      rxFormControlError
      [keepPlaceholder]="true"
      [customErrors]="mustMatchError"
      type="password"
    ></rx-input>
  </div>
</form>
